module.exports = __webpack_public_path__ + "static/endviolence_bn_img@2x-a194cee852f93bc6f6f867084f8308f4.png";